module.exports = __webpack_public_path__ + "static/media/Twitter stats red circle with line.389f1407.jpg";